export const STEP_NAMES = {
  originLocations: 'originLocations',
  destination: 'destination',
  venue: 'venue',
  detail: 'detail',
  summary: 'summary',
}

export const STEP_ORDER = [
  STEP_NAMES.originLocations,
  STEP_NAMES.destination,
  STEP_NAMES.venue,
  STEP_NAMES.detail,
  STEP_NAMES.summary,
]

export const STEPS_TO_DISPLAY_MODAL_IN = [
  STEP_NAMES.originLocations,
  STEP_NAMES.destination,
  STEP_NAMES.venue,
]
